import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../global.css";
import { getImageUrl } from "../../utils/imageHelper";

export default function LatestBride({ homeData }) {
  const sliderRef = useRef(null);

  const successList = (homeData?.testimonial || []).filter(
    (item) => item?.formType === "Success"
  );

  const count = successList.length;

  const settings = {
    infinite: count > 2,
    slidesToShow: count >= 2 ? 2 : 1,
    slidesToScroll: 1,
    autoplay: count > 2,
    autoplaySpeed: 3000,
    speed: 550,
    pauseOnHover: true,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: { slidesToShow: count >= 2 ? 2 : 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 500,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  if (count === 0) return null;

  // Single Bride / Success Image: Match the 16:9 video player exactly
  if (count === 1) {
    const item = successList[0];
    return (
      <div className="single-bride-container" style={{ width: "100%", maxWidth: "540px", margin: "0 auto", padding: "0 6px" }}>
        <div
          style={{
            position: "relative",
            width: "100%",
            paddingTop: "56.25%", /* Exact 16:9 Aspect Ratio matching Video Player */
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.15)",
            background: "#0f0c20",
          }}
        >
          <img
            src={getImageUrl(item.image_video)}
            alt={item.title || "Success Story"}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block",
            }}
          />
          {item.title && (
            <div
              style={{
                position: "absolute",
                bottom: "12px",
                left: "12px",
                background: "rgba(0, 0, 0, 0.65)",
                backdropFilter: "blur(8px)",
                color: "#ffffff",
                padding: "6px 14px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: "600",
                letterSpacing: "0.3px",
              }}
            >
              {item.title}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Multiple Bride Images: Match height and show slider
  return (
    <>
      <Slider ref={sliderRef} {...settings}>
        {successList.map((item, index) => (
          <div className="item" key={index} style={{ padding: "0 6px" }}>
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "115%", /* Elegant portrait aspect ratio for 2-column slide */
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.15)",
                background: "#0f0c20",
              }}
            >
              <img
                src={getImageUrl(item.image_video)}
                alt={item.title || "Success"}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center top",
                  display: "block",
                }}
              />
              {item.title && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "10px",
                    background: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(6px)",
                    color: "#ffffff",
                    padding: "4px 12px",
                    borderRadius: "16px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {item.title}
                </div>
              )}
            </div>
          </div>
        ))}
      </Slider>

      {count > 2 && (
        <div className="owl-nav-latest">
          <button onClick={() => sliderRef.current?.slickPrev()} type="button" role="presentation" className="owl-prev"><i className="fa-solid fa-angle-left"></i></button>
          <button onClick={() => sliderRef.current?.slickNext()} type="button" role="presentation" className="owl-next"><i className="fa-solid fa-angle-right"></i></button>
        </div>
      )}
    </>
  );
}
